import '.l{display:flex;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.n{gap:0.5rem;}.ssr-plugin'
import '.bc{cursor:pointer;}.ssr-plugin'
import '.e9{padding:0.75rem;}.ssr-plugin'
import '.b1{border-radius:1.25rem;}.ssr-plugin'
import '.b7{border:var(--border-subtle);}.ssr-plugin'
import '.b2{background-color:var(--palette-white);}.ssr-plugin'
import '.da{transition:background-color 0.2s ease;}.ssr-plugin'
import '.f7{width:2.5rem;}.ssr-plugin'
import '.f8{height:2.5rem;}.ssr-plugin'
import '.hh{color:var(--palette-blue-700);}.ssr-plugin'
import '.hi{font-size:0.9rem;}.ssr-plugin'
import '.bk{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="l a1 m aa n bc e9 b1 b7 b2 da"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="f7 f8 l aa a1 hh"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="hi hh bk"
        >
          {label}
        </span>
      </styled.button>
    )
}